// extracted by mini-css-extract-plugin
export default {"mb-3":"SectionCategory_mb-3__BI3s4","mb-2":"SectionCategory_mb-2__cPCOM","section":"SectionCategory_section__9Lk6P","header":"SectionCategory_header__cpVLJ"};